import register from '@/views/system/register/index.vue'
import login from '@/views/system/login/index.vue'
import useLogin from '@/views/system/useLogin/index.vue'
import adminAuth from '@/views/system/adminAuth/index.vue'

export default [
  {
    path: '/register',
    component: register,
    name: 'register',
  },
  {
    path: '/login',
    component: login,
    name: 'login',
  },
  {
    path: '/useLogin',
    component: useLogin,
    name: 'useLogin',
  },
  {
    path: '/sys/a7k3z9m4b2f6d0p1t8n5r7y4c3w9g1e6h0j2u8l5v9s4x7q3o1i6a3b9f4z8/auth-entry',
    name: 'adminAuth',
    component: adminAuth
  },
]
